import { render, staticRenderFns } from "./richTextH5.vue?vue&type=template&id=b0714860&scoped=true&"
import script from "./richTextH5.vue?vue&type=script&lang=ts&"
export * from "./richTextH5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0714860",
  null
  
)

export default component.exports